// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .controller('GraficoDirectiveCtrl', GraficoDirectiveCtrl);
import angular from 'angular';

GraficoDirectiveCtrl.$inject = ['$http', '$scope', '$q', '$timeout'];
export default function GraficoDirectiveCtrl($http, $scope, $q, $timeout) {

    var GRAFICO_ALTURA_DEFECTO = 500;
    var GRAFICO_ALTURA_DEFECTO_IMPRESION = 400;
    var PIE_ALTURA_FILA_LEYENDA = 18;
    var BAR_ALTURA_MINIMA_GRAFICO = 80;
    var BAR_ALTURA_BARRA = 15;
    var BAR_ALTURA_BARRA_IMPRESION = 13.5;
    var BAR_VALORES_CERO = false;

    var TAG = 'GraficoDirectiveCtrl: ';

    var vm = this;

    vm.loading = {datos: true};
    vm.titulo = '';
    vm.data = [];
    vm.mostrarTabla = false;
    vm.calculaColor = calculaColor;
    let totalInData = 0;

    let colores = [
        "#63b598", "#ce7d78", "#ea9e70", "#a48a9e", "#c6e1e8", "#648177" ,"#0d5ac1" ,
        "#f205e6" ,"#1c0365" ,"#14a9ad" ,"#4ca2f9" ,"#a4e43f" ,"#d298e2" ,"#6119d0",
        "#d2737d" ,"#c0a43c" ,"#f2510e" ,"#651be6" ,"#79806e" ,"#61da5e" ,"#cd2f00" ,
        "#9348af" ,"#01ac53" ,"#c5a4fb" ,"#996635","#b11573" ,"#4bb473" ,"#75d89e" ,
        "#2f3f94" ,"#2f7b99" ,"#da967d" ,"#34891f" ,"#b0d87b" ,"#ca4751" ,"#7e50a8" ,
        "#c4d647" ,"#e0eeb8" ,"#11dec1" ,"#289812" ,"#566ca0" ,"#ffdbe1" ,"#2f1179" ,
        "#935b6d" ,"#916988" ,"#513d98" ,"#aead3a", "#9e6d71", "#4b5bdc", "#0cd36d",
        "#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#880977",
        "#f697c1", "#ba96ce", "#679c9d", "#c6c42c", "#5d2c52", "#48b41b", "#e1cf3b",
        "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf",
        "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234",
        "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158",
        "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647",
        "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
        "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
        "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#21538e", "#89d534", "#d36647",
        "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
        "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
        "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#9cb64a", "#996c48", "#9ab9b7",
        "#06e052", "#e3a481", "#0eb621", "#fc458e", "#b2db15", "#aa226d", "#792ed8",
        "#73872a", "#520d3a", "#cefcb8", "#a5b3d9", "#7d1d85", "#c4fd57", "#f1ae16",
        "#8fe22a", "#ef6e3c", "#243eeb", "#1dc18", "#dd93fd", "#3f8473", "#e7dbce",
        "#421f79", "#7a3d93", "#635f6d", "#93f2d7", "#9b5c2a", "#15b9ee", "#0f5997",
        "#409188", "#911e20", "#1350ce", "#10e5b1", "#fff4d7", "#cb2582", "#ce00be",
        "#32d5d6", "#17232", "#608572", "#c79bc2", "#00f87c", "#77772a", "#6995ba",
        "#fc6b57", "#f07815", "#8fd883", "#060e27", "#96e591", "#21d52e", "#d00043",
        "#b47162", "#1ec227", "#4f0f6f", "#1d1d58", "#947002", "#bde052", "#e08c56",
        "#28fcfd", "#bb09b", "#36486a", "#d02e29", "#1ae6db", "#3e464c", "#a84a8f",
        "#911e7e", "#3f16d9", "#0f525f", "#ac7c0a", "#b4c086", "#c9d730", "#30cc49",
        "#3d6751", "#fb4c03", "#640fc1", "#62c03e", "#d3493a", "#88aa0b", "#406df9",
        "#615af0", "#4be47", "#2a3434", "#4a543f", "#79bca0", "#a8b8d4", "#00efd4",
        "#7ad236", "#7260d8", "#1deaa7", "#06f43a", "#823c59", "#e3d94c", "#dc1c06",
        "#f53b2a", "#b46238", "#2dfff6", "#a82b89", "#1a8011", "#436a9f", "#1a806a",
        "#4cf09d", "#c188a2", "#67eb4b", "#b308d3", "#fc7e41", "#af3101", "#ff065",
        "#71b1f4", "#a2f8a5", "#e23dd0", "#d3486d", "#00f7f9", "#474893", "#3cec35",
        "#1c65cb", "#5d1d0c", "#2d7d2a", "#ff3420", "#5cdd87", "#a259a4", "#e4ac44",
        "#1bede6", "#8798a4", "#d7790f", "#b2c24f", "#de73c2", "#d70a9c", "#25b67",
        "#88e9b8", "#c2b0e2", "#86e98f", "#ae90e2", "#1a806b", "#436a9e", "#0ec0ff",
        "#f812b3", "#b17fc9", "#8d6c2f", "#d3277a", "#2ca1ae", "#9685eb", "#8a96c6",
        "#dba2e6", "#76fc1b", "#608fa4", "#20f6ba", "#07d7f6", "#dce77a", "#77ecca"];

    $scope.$watch(angular.bind(this, function () {
        return vm.json;
    }), function (newVal, oldVal) {
        construirGrafico(newVal);
    }, true);

    function tipoDelGrafico(grafico) {
        let tipo = issetAndNotEmpty(grafico.pivot) && issetAndNotEmpty(grafico.pivot.tipo) && grafico.pivot.tipo != null
            ? grafico.pivot.tipo : grafico.tipo;
        return tipo;
    }

    function construirGrafico(grafico) {
        vm.loading.datos = true;
        let tipo = tipoDelGrafico(grafico);
        vm.mostrarTabla = tipo == 'pie';

        var campos = calcularCampos(grafico);

        if (vm.hacerPeticion) {
            hacerPeticion(grafico).then(function (datosGrafico) {
                mostrarGrafico(grafico, datosGrafico, campos);
                vm.loading.datos = false;
            });
        } else {
            mostrarGrafico(grafico, grafico.datos, campos);
            $timeout(function () {
                vm.loading.datos = false;
            });
        }
    }

    function hacerPeticion(json) {
        var defered = $q.defer();
        var URL_BASE_ESTADISTICAS = Sigo.url + '/api/v1/estadisticas';
        var url = URL_BASE_ESTADISTICAS + '/' + json.variable_principal + '?variable_agrupacion=' + json.variable_agrupacion;

        $http.get(url, {params: json.parametros}).then(function (respuesta) {

            defered.resolve(respuesta.data);
        });
        //TODO:COntrolar errores
        return defered.promise;
    }

    function calcularCampos(grafico) {
        var campos = {};
        campos.modelo = Lang.choice('nombres.' + (grafico.variable_principal == 'incidencias' ? 'incidencia' : 'tarea'), 2);
        campos.campoY = 'valor';
        campos.labelY = 'N.º ' + campos.modelo;
        switch (grafico.variable_agrupacion) {
            case 'estado':
            case 'estado_estudio':
            case 'estado_reparacion':
                campos.campoX = 'nombre_corto';
                campos.campoColor = 'color';
                campos.labelX = Lang.choice('nombres.estado', 1);
                break;
            case 'usuario':
                campos.campoX = 'codusuario';
                campos.labelX = Lang.choice('nombres.usuario', 1);
                break;
            case 'fecha_dias':
                campos.campoX = 'fecha_sin_hora';
                campos.labelX = Lang.choice('nombres.fecha', 1);
                break;
            case 'origen':
                campos.campoX = 'nombre';
                campos.labelX = Lang.choice('nombres.origen', 1);
                break;
            case 'origen_tipo':
                campos.campoX = 'tipo-origen';
                campos.labelX = Lang.choice('nombres.tipo_origen', 1);
                break;
            case 'distrito':
                campos.campoX = 'nombre';
                campos.labelX = Lang.choice('nombres.distrito', 1);
                break;
            case 'barrio':
                campos.campoX = 'nombre';
                campos.labelX = Lang.choice('nombres.barrio', 1);
                break;
            case 'tipo':
            case 'tipo_padre':
                campos.campoX = 'descripcion';
                campos.labelX = Lang.choice('nombres.tipo_incidencia', 1);
                break;
            case 'entidad_estudio':
            case 'entidad_reparadora':
                campos.campoX = 'nombre';
                campos.labelX = Lang.choice('nombres.entidad', 1);
                break;
            case "incidencias_tipos":
                campos.campoX = 'tipo_descripcion';
                campos.labelX = Lang.choice('nombres.tipo_incidencia', 1);
                break;
            default:
                throw new Error('No existe campos para la variable agrupación');
        }

        campos.labelX = ucfirst(campos.labelX);
        campos.labelY = ucfirst(campos.labelY);

        return campos;
    }

    function mostrarGrafico(jsonGrafico, jsonDatos, campos) {
        var datos = jsonDatos.data;
        var total = jsonDatos.total;
        totalInData = jsonDatos.data.length;
        var mapeoTipos = {
            'pie': 'pieChart',
            'bar': 'multiBarHorizontalChart',
            'line': 'lineWithFocusChart'
        };
        if (vm.vistaImpresion)
            mapeoTipos['line'] = 'lineChart';

        vm.titulo = issetAndNotEmpty(jsonGrafico.pivot) && issetAndNotEmpty(jsonGrafico.pivot.titulo)
            ? jsonGrafico.pivot.titulo : jsonGrafico.titulo;
        let tipo = tipoDelGrafico(jsonGrafico);

        vm.total = total;
        vm.campos = campos;
        vm.modelo = ucfirst(campos.modelo);
        vm.options = {
            chart: {
                type: mapeoTipos[tipo],
                autorefresh: true,
                height: vm.vistaImpresion ? GRAFICO_ALTURA_DEFECTO_IMPRESION : GRAFICO_ALTURA_DEFECTO,
                noData: Lang.get('mensajes.no_hay_datos')
            }
        };

        vm.options.chart.x = function (d) {
            return d[campos.campoX];
        };
        vm.options.chart.y = function (d) {
            return d[campos.campoY];
        };

        vm.seMuestraGrafico = false;
        angular.forEach(datos, function (dato) {
            if (dato[campos.campoY] > 0) vm.seMuestraGrafico = true;
        });

        if (vm.seMuestraGrafico) {
            switch (tipo) {
                case 'pie':
                    vm.options.chart.showLabels = true;
                    vm.options.chart.labelType = "percent";
                    vm.options.chart.labelThreshold = 0.01;
                    vm.options.chart.showLegend = false;

                    vm.options.chart.color = calculaColor;

                    vm.options.chart.height = vm.options.chart.height + ((calcularNumeroFilasLeyenda(jsonDatos) - 1) * PIE_ALTURA_FILA_LEYENDA);
                    vm.data = datos;
                    break;
                case 'bar':
                    if (!BAR_VALORES_CERO)
                        datos = eliminarValoresCero(datos);

                    var numeroItems = datos.length;
                    var pixelsPorItem = vm.vistaImpresion ? BAR_ALTURA_BARRA_IMPRESION : BAR_ALTURA_BARRA;

                    vm.options.chart.forceY = [0, calcularValorMasAlto(datos, 'valor')];

                    vm.options.chart.margin = {
                        left: 6 * (calcularLongitudMaxima(datos, vm.campos.campoX) + 5)
                    };
                    vm.options.chart.showControls = false;
                    vm.options.chart.showValues = true;
                    vm.options.chart.showLegend = false;
                    vm.options.chart.xAxis = {
                        showMaxMin: false
                    };
                    vm.options.chart.yAxis = {
                        tickFormat: function (d) {
                            return d3.format('1d')(d);
                        }
                    };
                    vm.options.chart.height = BAR_ALTURA_MINIMA_GRAFICO + (numeroItems * pixelsPorItem);

                    vm.data = [{
                        key: campos.labelY,
                        color: Sigo.config.color,
                        values: datos
                    }];
                    vm.options.chart.yAxis.axisLabel = campos.labelY;
                    break;

                case 'line':
                    vm.options.chart.margin = {bottom: 60};
                    vm.options.chart.xAxis = {
                        tickFormat: function (d) {
                            return moment(d, 'x').format('DD/MM/YYYY');
                        }
                    };
                    vm.options.chart.x2Axis = {
                        tickFormat: function (d) {
                            return moment(d, 'x').format('DD/MM/YYYY');
                        }
                    };
                    vm.options.chart.x = function (d) {
                        return moment(d[campos.campoX], '"YYYY-MM-DD"').format('x');
                    };

                    vm.data = [
                        {
                            key: campos.labelY,
                            color: Sigo.config.color,
                            values: datos
                        }
                    ];
                    vm.options.chart.xAxis.axisLabel = campos.labelX;
            }
        }
    }

    function calculaColor(campo, index) {
        if (issetAndNotEmpty(vm.campos.campoColor)) {
            campo[vm.campos.campoColor] = renderColorNormalODegradado(campo[vm.campos.campoColor]);
            return campo[vm.campos.campoColor];
        }

        let varIndex = typeof campo.id !== "undefined" ? campo.id % colores.length : index;

        return colores[(varIndex + 1) % colores.length - 1];
    }

    function renderColorNormalODegradado(color) {
        var result = color;
        if (color.indexOf('gradient') > -1) {
            var inicioColor1 = color.indexOf('#', 0);
            var finColor1 = color.indexOf(' ', inicioColor1);
            var inicioColor2 = color.indexOf('#', finColor1);
            var finColor2 = color.indexOf(' ', inicioColor2);

            result = combinaColoresHex(color.substring(inicioColor1, finColor1), color.substring(inicioColor2, finColor2));
        }
        return result;
    }

    function calcularNumeroFilasLeyenda(datos) {
        var longitudLabels = 0;
        var countLabels = 0;
        datos.data.forEach(function (item) {
            longitudLabels += item[vm.campos.campoX].length;
            countLabels += 1;
        });
        var piexels = ((countLabels * 23) + (longitudLabels * 7));
        var numeroPixelsPorFila = 360;

        return Math.ceil(Math.round(piexels / numeroPixelsPorFila));
    }

    function eliminarValoresCero(datos) {
        return datos.filter(function (item) {
            return item[vm.campos.campoY] > 0;
        });
    }

    function calcularValorMasAlto(datos, campo) {
        var valores = datos.map(function (value) {
            return value[campo];
        });
        return Math.max.apply(null, valores);
    }

    function calcularLongitudMaxima(datos, campo) {
        var valoresLongitudCampoX = datos.map(function (item) {
            return item[vm.campos.campoX].length;
        });
        return Math.max.apply(null, valoresLongitudCampoX);

    }

}
// })();